 window.lazySizesConfig = window.lazySizesConfig || {},
window.lazySizesConfig.loadMode = 1,
window.lazySizesConfig.loadHidden = !1,
function(e, t) {
    if (e) {
        var n = function() {
            t(e.lazySizes),
            e.removeEventListener("lazyunveilread", n, !0)
        };
        t = t.bind(null, e, e.document),
        "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
    }
}("undefined" != typeof window ? window : 0, function(u, i, f) {
    "use strict";
    var a, r, s, t, o, n, l, d, p, y, c, v, m, g, h, e, z = f.cfg, b = i.createElement("img"), E = "sizes"in b && "srcset"in b, A = /\s+\d+h/g, w = (r = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
    s = Array.prototype.forEach,
    function() {
        var e = i.createElement("img")
          , n = function(e) {
            var t, n, a = e.getAttribute(z.srcsetAttr);
            a && (n = a.match(r)) && ((t = "w" == n[2] ? n[1] / n[3] : n[3] / n[1]) && e.setAttribute("data-aspectratio", t),
            e.setAttribute(z.srcsetAttr, a.replace(A, "")))
        }
          , t = function(e) {
            if (e.detail.instance == f) {
                var t = e.target.parentNode;
                t && "PICTURE" == t.nodeName && s.call(t.getElementsByTagName("source"), n),
                n(e.target)
            }
        }
          , a = function() {
            e.currentSrc && i.removeEventListener("lazybeforeunveil", t)
        };
        i.addEventListener("lazybeforeunveil", t),
        e.onload = a,
        e.onerror = a,
        e.srcset = "data:,a 1w 1h",
        e.complete && a()
    }
    );
    (z.supportsType || (z.supportsType = function(e) {
        return !e
    }
    ),
    u.HTMLPictureElement && E) ? !f.hasHDescriptorFix && i.msElementsFromPoint && (f.hasHDescriptorFix = !0,
    w()) : u.picturefill || z.pf || (z.pf = function(e) {
        var t, n;
        if (!u.picturefill)
            for (t = 0,
            n = e.elements.length; t < n; t++)
                a(e.elements[t])
    }
    ,
    p = function(e, t) {
        return e.w - t.w
    }
    ,
    y = /^\s*\d+\.*\d*px\s*$/,
    n = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
    l = /\s/,
    d = function(e, t, n, a) {
        o.push({
            c: t,
            u: n,
            w: 1 * a
        })
    }
    ,
    v = function() {
        var e, n, t;
        v.init || (v.init = !0,
        addEventListener("resize", (n = i.getElementsByClassName("lazymatchmedia"),
        t = function() {
            var e, t;
            for (e = 0,
            t = n.length; e < t; e++)
                a(n[e])
        }
        ,
        function() {
            clearTimeout(e),
            e = setTimeout(t, 66)
        }
        )))
    }
    ,
    m = function(e, t) {
        var n, a = e.getAttribute("srcset") || e.getAttribute(z.srcsetAttr);
        !a && t && (a = e._lazypolyfill ? e._lazypolyfill._set : e.getAttribute(z.srcAttr) || e.getAttribute("src")),
        e._lazypolyfill && e._lazypolyfill._set == a || (n = c(a || ""),
        t && e.parentNode && (n.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase(),
        n.isPicture && u.matchMedia && (f.aC(e, "lazymatchmedia"),
        v())),
        n._set = a,
        Object.defineProperty(e, "_lazypolyfill", {
            value: n,
            writable: !0
        }))
    }
    ,
    g = function(e) {
        return u.matchMedia ? (g = function(e) {
            return !e || (matchMedia(e) || {}).matches
        }
        )(e) : !e
    }
    ,
    h = function(e) {
        var t, n, a, i, r, s, o, l, d, c;
        if (m(i = e, !0),
        (r = i._lazypolyfill).isPicture)
            for (n = 0,
            a = (t = e.parentNode.getElementsByTagName("source")).length; n < a; n++)
                if (z.supportsType(t[n].getAttribute("type"), e) && g(t[n].getAttribute("media"))) {
                    i = t[n],
                    m(i),
                    r = i._lazypolyfill;
                    break
                }
        return 1 < r.length ? (o = i.getAttribute("sizes") || "",
        o = y.test(o) && parseInt(o, 10) || f.gW(e, e.parentNode),
        r.d = (l = e,
        d = u.devicePixelRatio || 1,
        c = f.getX && f.getX(l),
        Math.min(c || d, 2.5, d)),
        !r.src || !r.w || r.w < o ? (r.w = o,
        s = function(e) {
            for (var t, n, a = e.length, i = e[a - 1], r = 0; r < a; r++)
                if ((i = e[r]).d = i.w / e.w,
                i.d >= e.d) {
                    !i.cached && (t = e[r - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (n = Math.pow(t.d - .6, 1.6),
                    t.cached && (t.d += .15 * n),
                    t.d + (i.d - e.d) * n > e.d && (i = t));
                    break
                }
            return i
        }(r.sort(p)),
        r.src = s) : s = r.src) : s = r[0],
        s
    }
    ,
    (e = function(e) {
        if (!E || !e.parentNode || "PICTURE" == e.parentNode.nodeName.toUpperCase()) {
            var t = h(e);
            t && t.u && e._lazypolyfill.cur != t.u && (e._lazypolyfill.cur = t.u,
            t.cached = !0,
            e.setAttribute(z.srcAttr, t.u),
            e.setAttribute("src", t.u))
        }
    }
    ).parse = c = function(e) {
        return o = [],
        (e = e.trim()).replace(A, "").replace(n, d),
        o.length || !e || l.test(e) || o.push({
            c: e,
            u: e,
            w: 99
        }),
        o
    }
    ,
    a = e,
    z.loadedClass && z.loadingClass && (t = [],
    ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(e) {
        t.push(e + z.loadedClass),
        t.push(e + z.loadingClass)
    }),
    z.pf({
        elements: i.querySelectorAll(t.join(", "))
    })))
}),
function(e, t) {
    var n = function() {
        t(e.lazySizes),
        e.removeEventListener("lazyunveilread", n, !0)
    };
    t = t.bind(null, e, e.document),
    "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
}(window, function(e, i, r) {
    "use strict";
    function s(e, t) {
        if (!d[e]) {
            var n = i.createElement(t ? "link" : "script")
              , a = i.getElementsByTagName("script")[0];
            t ? (n.rel = "stylesheet",
            n.href = e) : n.src = e,
            d[e] = !0,
            d[n.src || n.href] = !0,
            a.parentNode.insertBefore(n, a)
        }
    }
    var o, l, d = {};
    i.addEventListener && (o = function(e, t) {
        var n = i.createElement("img");
        n.onload = function() {
            n.onload = null,
            n.onerror = null,
            n = null,
            t()
        }
        ,
        n.onerror = n.onload,
        n.src = e,
        n && n.complete && n.onload && n.onload()
    }
    ,
    addEventListener("lazybeforeunveil", function(e) {
        var t, n, a;
        if (e.detail.instance == r && !e.defaultPrevented) {
            var i = e.target;
            if ("none" == i.preload && (i.preload = "auto"),
            null != i.getAttribute("data-autoplay"))
                if (i.getAttribute("data-expand") && !i.autoplay)
                    try {
                        i.play()
                    } catch (e) {}
                else
                    requestAnimationFrame(function() {
                        i.setAttribute("data-expand", "-10"),
                        r.aC(i, r.cfg.lazyClass)
                    });
            (t = i.getAttribute("data-link")) && s(t, !0),
            (t = i.getAttribute("data-script")) && s(t),
            (t = i.getAttribute("data-require")) && (r.cfg.requireJs ? r.cfg.requireJs([t]) : s(t)),
            (n = i.getAttribute("data-bg")) && (e.detail.firesLoad = !0,
            o(n, function() {
                i.style.backgroundImage = "url(" + (l.test(n) ? JSON.stringify(n) : n) + ")",
                e.detail.firesLoad = !1,
                r.fire(i, "_lazyloaded", {}, !0, !0)
            })),
            (a = i.getAttribute("data-poster")) && (e.detail.firesLoad = !0,
            o(a, function() {
                i.poster = a,
                e.detail.firesLoad = !1,
                r.fire(i, "_lazyloaded", {}, !0, !0)
            }))
        }
    }, !(l = /\(|\)|\s|'/)))
}),
function(e, t) {
    var n = function() {
        t(e.lazySizes),
        e.removeEventListener("lazyunveilread", n, !0)
    };
    t = t.bind(null, e, e.document),
    "object" == typeof module && module.exports ? t(require("lazysizes")) : "function" == typeof define && define.amd ? define(["lazysizes"], t) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
}(window, function(e, t, n) {
    "use strict";
    addEventListener("lazybeforeunveil", function(e) {
        var t = e.target.getAttribute("data-bgset");
        if (!(e.defaultPrevented || !t || t.indexOf("_1x1.") < 0)) {
            var n = t;
            t = "";
            if (e.target.hasAttribute("data-widths"))
                var a = JSON.parse(e.target.getAttribute("data-widths"));
            else if (e.target.hasAttribute("data-wiis"))
                a = [180, 360, 540, 720, 900, 1080];
            else
                a = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950, 2100, 2260, 2450, 2700, 3e3, 3350, 3750, 4100];
            var i, r = a.length;
            for (i = 0; i < r; i++)
                t += n.replace("_1x1.", "_" + a[i] + "x.") + " " + a[i] + "w, ";
            t = t.slice(0, -2),
            e.target.setAttribute("data-bgset", t)
        }
    }, !0)
}),
function(e, t) {
    var n = function() {
        t(e.lazySizes),
        e.removeEventListener("lazyunveilread", n, !0)
    };
    t = t.bind(null, e, e.document),
    "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
}(window, function(e, u, f) {
    "use strict";
    if (e.addEventListener) {
        var p = f.cfg
          , y = /\s+/g
          , v = /\s*\|\s+|\s+\|\s*/g
          , m = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/
          , a = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/
          , r = /\(|\)|'/
          , s = {
            contain: 1,
            cover: 1
        }
          , g = function(e, t) {
            if (t) {
                var n = t.match(a);
                n && n[1] ? e.setAttribute("type", n[1]) : e.setAttribute("media", p.customMedia[t] || t)
            }
        }
          , h = function(e) {
            if (e.target._lazybgset) {
                var t = e.target
                  , n = t._lazybgset
                  , a = t.currentSrc || t.src;
                if (a) {
                    var i = f.fire(n, "bgsetproxy", {
                        src: a,
                        useSrc: r.test(a) ? JSON.stringify(a) : a
                    });
                    i.defaultPrevented || (n.style.backgroundImage = "url(" + i.detail.useSrc + ")")
                }
                t._lazybgsetLoading && (f.fire(n, "_lazyloaded", {}, !1, !0),
                delete t._lazybgsetLoading)
            }
        };
        addEventListener("lazybeforeunveil", function(e) {
            var t, n, a, i, r, s, o, l, d, c;
            !e.defaultPrevented && (t = e.target.getAttribute("data-bgset")) && (a = e.target,
            (n = u.createElement("img")).alt = "",
            n._lazybgsetLoading = !0,
            e.detail.firesLoad = !0,
            i = t,
            r = a,
            s = n,
            o = u.createElement("picture"),
            l = r.getAttribute(p.sizesAttr),
            d = r.getAttribute("data-ratio"),
            c = r.getAttribute("data-optimumx"),
            r._lazybgset && r._lazybgset.parentNode == r && r.removeChild(r._lazybgset),
            Object.defineProperty(s, "_lazybgset", {
                value: r,
                writable: !0
            }),
            Object.defineProperty(r, "_lazybgset", {
                value: o,
                writable: !0
            }),
            i = i.replace(y, " ").split(v),
            o.style.display = "none",
            s.className = p.lazyClass,
            1 != i.length || l || (l = "auto"),
            i.forEach(function(e) {
                var t, n = u.createElement("source");
                l && "auto" != l && n.setAttribute("sizes", l),
                (t = e.match(m)) ? (n.setAttribute(p.srcsetAttr, t[1]),
                g(n, t[2]),
                g(n, t[3])) : n.setAttribute(p.srcsetAttr, e),
                o.appendChild(n)
            }),
            l && (s.setAttribute(p.sizesAttr, l),
            r.removeAttribute(p.sizesAttr),
            r.removeAttribute("sizes")),
            c && s.setAttribute("data-optimumx", c),
            d && s.setAttribute("data-ratio", d),
            o.appendChild(s),
            r.appendChild(o),
            setTimeout(function() {
                f.loader.unveil(n),
                f.rAF(function() {
                    f.fire(n, "_lazyloaded", {}, !0, !0),
                    n.complete && h({
                        target: n
                    })
                })
            }))
        }),
        u.addEventListener("load", h, !0),
        e.addEventListener("lazybeforesizes", function(e) {
            var t, n;
            if (e.detail.instance == f && (e.target._lazybgset && e.detail.dataAttr)) {
                var a = e.target._lazybgset
                  , i = a.dataset.parentFit || (t = a,
                n = (getComputedStyle(t) || {
                    getPropertyValue: function() {}
                }).getPropertyValue("background-size"),
                !s[n] && s[t.style.backgroundSize] && (n = t.style.backgroundSize),
                n);
                s[i] && (e.target._lazysizesParentFit = i,
                f.rAF(function() {
                    e.target.setAttribute("data-parent-fit", i),
                    e.target._lazysizesParentFit && delete e.target._lazysizesParentFit
                }))
            }
        }, !0),
        u.documentElement.addEventListener("lazybeforesizes", function(e) {
            var t, n;
            !e.defaultPrevented && e.target._lazybgset && e.detail.instance == f && (e.detail.width = (t = e.target._lazybgset,
            n = f.gW(t, t.parentNode),
            (!t._lazysizesWidth || n > t._lazysizesWidth) && (t._lazysizesWidth = n),
            t._lazysizesWidth))
        })
    }
}),
function(e, t) {
    var n = function() {
        t(e.lazySizes),
        e.removeEventListener("lazyunveilread", n, !0)
    };
    t = t.bind(null, e, e.document),
    "object" == typeof module && module.exports ? t(require("lazysizes")) : "function" == typeof define && define.amd ? define(["lazysizes"], t) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
}(window, function(i, o, E) {
    "use strict";
    if (o.getElementsByClassName) {
        var r, l, s, d, e, t, n, a, c, u, f, p, y, v = /\s*,+\s+/, m = {
            complete: 1,
            loaded: 1
        }, g = {}, h = /\s+/, z = /^(amd|css|module)\:(.+)/i, b = /(.+)\s+(\(\s*(.+)\s*\))/, A = /['"]/g, w = o.documentElement, C = o.getElementsByClassName("lazyconditionalinclude"), _ = function(e, t) {
            var n = e.ownerDocument.defaultView;
            return n.opener || (n = i),
            n.getComputedStyle(e, t || null) || {
                getPropertyValue: function() {},
                isNull: !0
            }
        }, L = (n = 2,
        c = a = 0,
        u = [],
        t = function() {
            u.length && (a = 0)
        }
        ,
        f = function() {
            clearTimeout(e),
            e = setTimeout(t, 999)
        }
        ,
        {
            q: function(e) {
                var t = null == e.getAttribute("data-lazyqueue");
                t && (c++,
                n = 3),
                n < a ? u[t ? "unshift" : "push"](e) : O(e) && (a++,
                f())
            },
            d: function() {
                if (a && a--,
                0 < c && (--c || (n = 2)),
                !(n < a)) {
                    for (; u.length; )
                        if (O(u.shift())) {
                            a++;
                            break
                        }
                    f()
                }
            }
        }), S = (y = function() {
            for (var e = 0, t = C.length; e < t; e++)
                !E.hC(C[e], r.lazyClass) && x(C[e]) && E.aC(C[e], r.lazyClass)
        }
        ,
        function(e) {
            clearTimeout(p),
            d = null,
            p = setTimeout(y, "resize" == e.type ? 31 : 0)
        }
        );
        (r = E && E.cfg).include || (r.include = {}),
        (l = r.include).contentElement || (l.contentElement = "html"),
        l.conditions || (l.conditions = {}),
        l.map || (l.map = {}),
        addEventListener("lazybeforeunveil", function(e) {
            e.detail.instance == E && !e.defaultPrevented && e.target.getAttribute("data-include") && (L.q(e.target),
            e.detail.firesLoad = !0)
        }, !1),
        addEventListener("resize", S, !1),
        addEventListener("lazyrefreshincludes", S, !1)
    }
    function N(e) {
        var t;
        (t = e.match(z)) ? this.urls[t[1]] = l.map[t[2]] || t[2] : this.urls.include = l.map[e] || e
    }
    function T(e) {
        var t, n, a;
        return e = e.trim(),
        (t = (n = (e = l.map[e] || e).match(b)) ? (a = n[1],
        {
            condition: r.include.conditions[n[3]] || r.customMedia[n[3]] || n[2] || null,
            name: n[3]
        }) : (a = e,
        {
            condition: null,
            name: ""
        })).urls = {},
        (l.map[a] || a).split(h).forEach(N, t),
        !t.urls.include && t.urls.amd && (this.saved = !0,
        t.initial = this),
        t
    }
    function P(e, t) {
        var n, a = !t.condition;
        return t.condition && (d || (s || (s = o.querySelector(l.contentElement)),
        s ? (n = (_(s, ":after").getPropertyValue("content") || "none").replace(A, ""),
        d = {},
        n && (d[n] = 1),
        (n = (_(s, ":before").getPropertyValue("content") || "none").replace(A, "")) && (d[n] = 1)) : d = {}),
        d[t.name] ? a = !0 : i.matchMedia && "string" == typeof t.condition ? a = (matchMedia(t.condition) || {}).matches : "function" == typeof t.condition && (a = t.condition(e, t))),
        a
    }
    function x(e) {
        var t, n, a = e.lazyInclude;
        if (a && a.candidates)
            for (t = 0; t < a.candidates.length && !P(e, n = a.candidates[t]); t++)
                ;
        return n && n != a.current || (n = null),
        n
    }
    function M(n, e, t) {
        if (g[n])
            t && (!0 === g[n] ? setTimeout(t) : g[n].push(t));
        else {
            var a = o.createElement(!0 === e ? "script" : "link")
              , i = o.getElementsByTagName("script")[0];
            if (e ? (a.src = n,
            a.async = !1) : (a.rel = "stylesheet",
            a.href = n),
            g[n] = [],
            g[a.href] = g[n],
            t) {
                var r, s = function(e) {
                    if ("readystatechange" != e.type || m[e.target.readyState]) {
                        var t = g[n];
                        for (a.removeEventListener("load", s),
                        a.removeEventListener("error", s),
                        a.removeEventListener("readystatechange", s),
                        a.removeEventListener("loadcssdefined", s),
                        r && clearInterval(r),
                        g[n] = !0,
                        g[a.href] = !0; t.length; )
                            t.shift()()
                    }
                };
                g[a.href][0] = t,
                e || (r = setInterval(function() {
                    (function(e) {
                        for (var t = !1, n = o.styleSheets, a = e.href, i = 0, r = n.length; i < r; i++)
                            if (n[i].href == a) {
                                t = !0;
                                break
                            }
                        return t
                    }
                    )(a) && s({})
                }, 60)),
                a.addEventListener("load", s),
                a.addEventListener("error", s),
                a.addEventListener("readystatechange", s),
                a.addEventListener("loadcssdefined", s)
            }
            i.parentNode.insertBefore(a, i)
        }
    }
    function q(e) {
        e && "function" == typeof e.lazytransform && e.lazytransform(this)
    }
    function k(e) {
        e && "function" == typeof e.lazyunload && e.lazyunload(this)
    }
    function j(e) {
        e && "function" == typeof e.lazyload && e.lazyload(this)
    }
    function F(s, o) {
        var e, l, d, t, n, c = s.lazyInclude.current || null, a = {
            candidate: o,
            openArgs: ["GET", o.urls.include, !0],
            sendData: null,
            xhrModifier: null,
            content: o.content && o.content.content || o.content,
            oldCandidate: c
        };
        if (E.fire(s, "lazyincludeload", a).defaultPrevented)
            L.d();
        else {
            var i, r, u, f, p, y, v, m, g, h, z;
            if (n = function() {
                l && d && !t && e()
            }
            ,
            e = function() {
                var e, t = l.status, n = l.content || l.responseText, a = !(null != n || !c || !c.urls.include), i = {
                    candidate: o,
                    content: n,
                    text: l.responseText || l.content,
                    response: l.response,
                    xml: l.responseXML,
                    isSuccess: !("status"in l) || (200 <= t && t < 300 || 304 === t),
                    oldCandidate: c,
                    insert: !0,
                    resetHTML: a
                }, r = {
                    target: s,
                    details: i,
                    detail: i
                };
                o.modules = d,
                c && c.modules && (c.modules.forEach(k, r),
                c.modules = null,
                i.resetHTML && null == i.content && o.initial && o.initial.saved && (i.content = o.initial.content)),
                d.forEach(q, r),
                e = E.fire(s, "lazyincludeloaded", i),
                i.insert && i.isSuccess && !e.defaultPrevented && null != i.content && i.content != s.innerHTML && (s.innerHTML = i.content),
                L.d(),
                d.forEach(j, r),
                setTimeout(function() {
                    E.fire(s, "lazyincluded", i)
                }),
                d = l = null
            }
            ,
            s.lazyInclude.current = o,
            s.setAttribute("data-currentinclude", o.name),
            o.urls.css && (t = !0,
            i = o.urls.css,
            r = function() {
                t = !1,
                n()
            }
            ,
            u = (i = i.split("|,|")).length - 1,
            i.forEach(function(e, t) {
                M(e, !1, t == u ? r : null)
            })),
            null == a.content && o.urls.include ? (f = a,
            p = function(e) {
                l = e,
                n()
            }
            ,
            (y = new XMLHttpRequest).addEventListener("readystatechange", function() {
                var e = this.DONE || 4;
                this.readyState === e && (p(y),
                y = null)
            }, !1),
            y.open.apply(y, f.openArgs),
            y.setRequestHeader("X-Requested-With", "XMLHttpRequest"),
            f.xhrModifier && f.xhrModifier(y, f.candidate),
            y.send(f.sendData)) : l = a,
            o.urls.amd || o.urls.module) {
                var b = function() {
                    d = Array.prototype.slice.call(arguments),
                    n()
                };
                o.urls.amd ? (g = o.urls.amd,
                h = b,
                z = (g = g.split("|,|")).length - 1,
                E.cfg.requireJs ? E.cfg.requireJs(g, h) : g.forEach(function(e, t) {
                    M(e, t == z ? h : null)
                })) : (v = o.urls.module,
                m = b,
                E.cfg.systemJs ? E.cfg.systemJs(v, m) : M(v, m))
            } else
                d = [];
            n()
        }
    }
    function O(e) {
        var t, n, a, i, r, s;
        if ((r = (n = e).getAttribute("data-include") || "",
        (s = n.lazyInclude) && s.str == r && !l.allowReload || (i = {
            saved: !1,
            content: null
        },
        !(a = (s = {
            str: r,
            candidates: (l.map[r] || r).split(v).map(T, i)
        }).candidates.length) || s.candidates[a - 1].condition ? (i.saved = !0,
        s.candidates.push({
            urls: {},
            condition: null,
            name: "initial",
            content: i
        })) : i.saved && 1 == s.candidates.length && (i.saved = !1),
        (s.initialContent = i).saved && (i.content = n.innerHTML),
        1 < (n.lazyInclude = s).candidates.length ? E.aC(n, "lazyconditionalinclude") : E.rC(n, "lazyconditionalinclude")),
        s).candidates.length && w.contains(e))
            return (t = x(e)) && F(e, t),
            !0
    }
}),
function(e, t) {
    if (e) {
        var n = function() {
            t(e.lazySizes),
            e.removeEventListener("lazyunveilread", n, !0)
        };
        t = t.bind(null, e, e.document),
        "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
    }
}("undefined" != typeof window ? window : 0, function(p, y, v) {
    "use strict";
    var m = function() {
        var e, t, n, a, i, r, s, o = v.cfg, l = {
            "data-bgset": 1,
            "data-include": 1,
            "data-poster": 1,
            "data-bg": 1,
            "data-script": 1
        }, d = "(\\s|^)(" + o.loadedClass, c = y.documentElement, u = function(e) {
            v.rAF(function() {
                v.rC(e, o.loadedClass),
                o.unloadedClass && v.rC(e, o.unloadedClass),
                v.aC(e, o.lazyClass),
                ("none" == e.style.display || e.parentNode && "none" == e.parentNode.style.display) && setTimeout(function() {
                    v.loader.unveil(e)
                }, 0)
            })
        }, f = function(e) {
            var t, n, a, i;
            for (t = 0,
            n = e.length; t < n; t++)
                (i = (a = e[t]).target).getAttribute(a.attributeName) && ("source" == i.localName && i.parentNode && (i = i.parentNode.querySelector("img")),
                i && d.test(i.className) && u(i))
        };
        o.unloadedClass && (d += "|" + o.unloadedClass),
        d += "|" + o.loadingClass + ")(\\s|$)",
        d = new RegExp(d),
        l[o.srcAttr] = 1,
        l[o.srcsetAttr] = 1,
        t = p.MutationObserver ? (n = new MutationObserver(f),
        e = function() {
            a || (a = !0,
            n.observe(c, {
                subtree: !0,
                attributes: !0,
                attributeFilter: Object.keys(l)
            }))
        }
        ,
        function() {
            a && (a = !1,
            n.disconnect())
        }
        ) : (c.addEventListener("DOMAttrModified", (r = [],
        s = function() {
            f(r),
            i = !(r = [])
        }
        ,
        function(e) {
            a && l[e.attrName] && e.newValue && (r.push({
                target: e.target,
                attributeName: e.attrName
            }),
            i || (setTimeout(s),
            i = !0))
        }
        ), !0),
        e = function() {
            a = !0
        }
        ,
        function() {
            a = !1
        }
        ),
        addEventListener("lazybeforeunveil", t, !0),
        addEventListener("lazybeforeunveil", e),
        addEventListener("lazybeforesizes", t, !0),
        addEventListener("lazybeforesizes", e),
        e(),
        removeEventListener("lazybeforeunveil", m)
    };
    addEventListener("lazybeforeunveil", m)
}),
function(e, t) {
    if (e) {
        var n = function() {
            t(e.lazySizes),
            e.removeEventListener("lazyunveilread", n, !0)
        };
        t = t.bind(null, e, e.document),
        "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
    }
}("undefined" != typeof window ? window : 0, function(c, e, n) {
    "use strict";
    if (c.addEventListener) {
        var u = /\s+(\d+)(w|h)\s+(\d+)(w|h)/
          , s = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/
          , o = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/
          , f = /^picture$/i
          , p = n.cfg
          , l = {
            getParent: function(e, t) {
                var n = e
                  , a = e.parentNode;
                return t && "prev" != t || !a || !f.test(a.nodeName || "") || (a = a.parentNode),
                "self" != t && (n = "prev" == t ? e.previousElementSibling : t && (a.closest || c.jQuery) && (a.closest ? a.closest(t) : jQuery(a).closest(t)[0]) || a),
                n
            },
            getFit: function(e) {
                var t, n, a = getComputedStyle(e, null) || {}, i = a.content || a.fontFamily, r = {
                    fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit")
                };
                return !r.fit && i && (t = i.match(s)) && (r.fit = t[1]),
                r.fit ? (!(n = e._lazysizesParentContainer || e.getAttribute("data-parent-container")) && i && (t = i.match(o)) && (n = t[1]),
                r.parent = l.getParent(e, n)) : r.fit = a.objectFit,
                r
            },
            getImageRatio: function(e) {
                var t, n, a, i, r, s, o, l = e.parentNode, d = l && f.test(l.nodeName || "") ? l.querySelectorAll("source, img") : [e];
                for (t = 0; t < d.length; t++)
                    if (n = (e = d[t]).getAttribute(p.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || "",
                    a = e._lsMedia || e.getAttribute("media"),
                    a = p.customMedia[e.getAttribute("data-media") || a] || a,
                    n && (!a || (c.matchMedia && matchMedia(a) || {}).matches)) {
                        (i = parseFloat(e.getAttribute("data-aspectratio"))) || (o = (r = n.match(u)) ? "w" == r[2] ? (s = r[1],
                        r[3]) : (s = r[3],
                        r[1]) : (s = e.getAttribute("width"),
                        e.getAttribute("height")),
                        i = s / o);
                        break
                    }
                return i
            },
            calculateSize: function(e, t) {
                var n, a, i, r = this.getFit(e), s = r.fit, o = r.parent;
                return "width" == s || ("contain" == s || "cover" == s) && (a = this.getImageRatio(e)) ? (o ? t = o.clientWidth : o = e,
                i = t,
                "width" == s ? i = t : (n = t / o.clientHeight) && ("cover" == s && n < a || "contain" == s && a < n) && (i = t * (a / n)),
                i) : t
            }
        };
        n.parentFit = l,
        e.addEventListener("lazybeforesizes", function(e) {
            if (!e.defaultPrevented && e.detail.instance == n) {
                var t = e.target;
                e.detail.width = l.calculateSize(t, e.detail.width)
            }
        })
    }
}),
function(e, t) {
    var n = function() {
        t(e.lazySizes),
        e.removeEventListener("lazyunveilread", n, !0)
    };
    t = t.bind(null, e, e.document),
    "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
}(window, function(u, d, y) {
    "use strict";
    function v(e, t, n) {
        var r, s, o, a = 0, i = 0, l = n;
        if (e) {
            if ("container" === t.ratio) {
                for (a = l.scrollWidth,
                i = l.scrollHeight; !(a && i || l === d); )
                    a = (l = l.parentNode).scrollWidth,
                    i = l.scrollHeight;
                a && i && (t.ratio = t.traditionalRatio ? i / a : a / i)
            }
            r = e,
            s = t,
            (o = []).srcset = [],
            s.absUrl && (w.setAttribute("href", r),
            r = w.href),
            r = ((s.prefix || "") + r + (s.postfix || "")).replace(p, function(e, t) {
                return c[typeof s[t]] ? s[t] : e
            }),
            s.widths.forEach(function(e) {
                var t = s.widthmap[e] || e
                  , n = s.aspectratio || s.ratio
                  , a = !s.aspectratio && z.traditionalRatio
                  , i = {
                    u: r.replace(b, t).replace(f, n ? a ? Math.round(e * n) : Math.round(e / n) : ""),
                    w: e
                };
                o.push(i),
                o.srcset.push(i.c = i.u + " " + e + "w")
            }),
            (e = o).isPicture = t.isPicture,
            C && "IMG" == n.nodeName.toUpperCase() ? n.removeAttribute(h.srcsetAttr) : n.setAttribute(h.srcsetAttr, e.srcset.join(", ")),
            Object.defineProperty(n, "_lazyrias", {
                value: e,
                writable: !0
            })
        }
    }
    function m(e, t) {
        var n = function(i, e) {
            var t, n, a, r, s = u.getComputedStyle(i);
            for (t in n = i.parentNode,
            r = {
                isPicture: !(!n || !l.test(n.nodeName || ""))
            },
            a = function(e, t) {
                var n = i.getAttribute("data-" + e);
                if (!n) {
                    var a = s.getPropertyValue("--ls-" + e);
                    a && (n = a.trim())
                }
                if (n) {
                    if ("true" == n)
                        n = !0;
                    else if ("false" == n)
                        n = !1;
                    else if (o.test(n))
                        n = parseFloat(n);
                    else if ("function" == typeof z[e])
                        n = z[e](i, n);
                    else if (E.test(n))
                        try {
                            n = JSON.parse(n)
                        } catch (e) {}
                    r[e] = n
                } else
                    e in z && "function" != typeof z[e] ? r[e] = z[e] : t && "function" == typeof z[e] && (r[e] = z[e](i, n))
            }
            ,
            z)
                a(t);
            return e.replace(p, function(e, t) {
                t in r || a(t, !0)
            }),
            r
        }(e, t);
        return z.modifyOptions.call(e, {
            target: e,
            details: n,
            detail: n
        }),
        y.fire(e, "lazyriasmodifyoptions", n),
        n
    }
    function g(e) {
        return e.getAttribute(e.getAttribute("data-srcattr") || z.srcAttr) || e.getAttribute(h.srcsetAttr) || e.getAttribute(h.srcAttr) || e.getAttribute("data-pfsrcset") || ""
    }
    var h, z, a = y.cfg, c = {
        string: 1,
        number: 1
    }, o = /^\-*\+*\d+\.*\d*$/, l = /^picture$/i, b = /\s*\{\s*width\s*\}\s*/i, f = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, E = /^\[.*\]|\{.*\}$/, A = /^(?:auto|\d+(px)?)$/, w = d.createElement("a"), e = d.createElement("img"), C = "srcset"in e && !("sizes"in e), _ = !!u.HTMLPictureElement && !C;
    !function() {
        var e, t = {
            prefix: "",
            postfix: "",
            srcAttr: "data-src",
            absUrl: !1,
            modifyOptions: function() {},
            widthmap: {},
            ratio: !1,
            traditionalRatio: !1,
            aspectratio: !1
        };
        for (e in (h = y && y.cfg).supportsType || (h.supportsType = function(e) {
            return !e
        }
        ),
        h.rias || (h.rias = {}),
        "widths"in (z = h.rias) || (z.widths = [],
        function(e) {
            for (var t, n = 0; !t || t < 3e3; )
                30 < (n += 5) && (n += 1),
                t = 36 * n,
                e.push(t)
        }(z.widths)),
        t)
            e in z || (z[e] = t[e])
    }(),
    addEventListener("lazybeforesizes", function(e) {
        var t, n, a, i, r, s, o, l, d, c, u, f, p;
        if (e.detail.instance == y && (t = e.target,
        e.detail.dataAttr && !e.defaultPrevented && !z.disabled && (d = t.getAttribute(h.sizesAttr) || t.getAttribute("sizes")) && A.test(d))) {
            if (a = m(t, n = g(t)),
            u = b.test(a.prefix) || b.test(a.postfix),
            a.isPicture && (i = t.parentNode))
                for (s = 0,
                o = (r = i.getElementsByTagName("source")).length; s < o; s++)
                    (u || b.test(l = g(r[s]))) && (v(l, a, r[s]),
                    f = !0);
            u || b.test(n) ? (v(n, a, t),
            f = !0) : f && ((p = []).srcset = [],
            p.isPicture = !0,
            Object.defineProperty(t, "_lazyrias", {
                value: p,
                writable: !0
            })),
            f && (_ ? t.removeAttribute(h.srcAttr) : "auto" != d && (c = {
                width: parseInt(d, 10)
            },
            N({
                target: t,
                detail: c
            })))
        }
    }, !0);
    var L, S, i, r, N = (L = function(e, t) {
        return e.w - t.w
    }
    ,
    S = function(e, t) {
        var n;
        return !e._lazyrias && y.pWS && (n = y.pWS(e.getAttribute(h.srcsetAttr || ""))).length && (Object.defineProperty(e, "_lazyrias", {
            value: n,
            writable: !0
        }),
        t && e.parentNode && (n.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
        e._lazyrias
    }
    ,
    i = function(e, t) {
        var n, a, i, r, s, o, l, d, c;
        if ((s = e._lazyrias).isPicture && u.matchMedia)
            for (a = 0,
            i = (n = e.parentNode.getElementsByTagName("source")).length; a < i; a++)
                if (S(n[a]) && !n[a].getAttribute("type") && (!(r = n[a].getAttribute("media")) || (matchMedia(r) || {}).matches)) {
                    s = n[a]._lazyrias;
                    break
                }
        return (!s.w || s.w < t) && (s.w = t,
        s.d = (l = e,
        d = u.devicePixelRatio || 1,
        c = y.getX && y.getX(l),
        Math.min(c || d, 2.4, d)),
        o = function(e) {
            for (var t, n, a = e.length, i = e[a - 1], r = 0; r < a; r++)
                if ((i = e[r]).d = i.w / e.w,
                i.d >= e.d) {
                    !i.cached && (t = e[r - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (n = Math.pow(t.d - .6, 1.6),
                    t.cached && (t.d += .15 * n),
                    t.d + (i.d - e.d) * n > e.d && (i = t));
                    break
                }
            return i
        }(s.sort(L))),
        o
    }
    ,
    r = function(e) {
        if (e.detail.instance == y) {
            var t, n = e.target;
            if (!C && (u.respimage || u.picturefill || a.pf))
                return void d.removeEventListener("lazybeforesizes", r);
            ("_lazyrias"in n || e.detail.dataAttr && S(n, !0)) && (t = i(n, e.detail.width)) && t.u && n._lazyrias.cur != t.u && (n._lazyrias.cur = t.u,
            t.cached = !0,
            y.rAF(function() {
                n.setAttribute(h.srcAttr, t.u),
                n.setAttribute("src", t.u)
            }))
        }
    }
    ,
    _ ? r = function() {}
    : addEventListener("lazybeforesizes", r),
    r)
}),
function(e, t) {
    var n = function(a, p, r) {
        "use strict";
        var y, v;
        if (function() {
            var e, t = {
                lazyClass: "lazyload",
                loadedClass: "lazyloaded",
                loadingClass: "lazyloading",
                preloadClass: "lazypreload",
                errorClass: "lazyerror",
                autosizesClass: "lazyautosizes",
                srcAttr: "data-src",
                srcsetAttr: "data-srcset",
                sizesAttr: "data-sizes",
                minSize: 40,
                customMedia: {},
                init: !0,
                expFactor: 1.5,
                hFac: .8,
                loadMode: 2,
                loadHidden: !0,
                ricTimeout: 0,
                throttleDelay: 125
            };
            for (e in v = a.lazySizesConfig || a.lazysizesConfig || {},
            t)
                e in v || (v[e] = t[e])
        }(),
        !p || !p.getElementsByClassName)
            return {
                init: function() {},
                cfg: v,
                noSupport: !0
            };
        var m = p.documentElement
          , i = a.HTMLPictureElement
          , s = "addEventListener"
          , g = "getAttribute"
          , e = a[s].bind(a)
          , u = a.setTimeout
          , n = a.requestAnimationFrame || u
          , o = a.requestIdleCallback
          , f = /^picture$/i
          , l = ["load", "error", "lazyincluded", "_lazyloaded"]
          , d = {}
          , h = Array.prototype.forEach
          , c = function(e, t) {
            return d[t] || (d[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
            d[t].test(e[g]("class") || "") && d[t]
        }
          , z = function(e, t) {
            c(e, t) || e.setAttribute("class", (e[g]("class") || "").trim() + " " + t)
        }
          , b = function(e, t) {
            var n;
            (n = c(e, t)) && e.setAttribute("class", (e[g]("class") || "").replace(n, " "))
        }
          , E = function(t, n, e) {
            var a = e ? s : "removeEventListener";
            e && E(t, n),
            l.forEach(function(e) {
                t[a](e, n)
            })
        }
          , A = function(e, t, n, a, i) {
            var r = p.createEvent("Event");
            return n || (n = {}),
            n.instance = y,
            r.initEvent(t, !a, !i),
            r.detail = n,
            e.dispatchEvent(r),
            r
        }
          , w = function(e, t) {
            var n;
            !i && (n = a.picturefill || v.pf) ? (t && t.src && !e[g]("srcset") && e.setAttribute("srcset", t.src),
            n({
                reevaluate: !0,
                elements: [e]
            })) : t && t.src && (e.src = t.src)
        }
          , C = function(e, t) {
            return (getComputedStyle(e, null) || {})[t]
        }
          , _ = function(e, t, n) {
            for (n = n || e.offsetWidth; n < v.minSize && t && !e._lazysizesWidth; )
                n = t.offsetWidth,
                t = t.parentNode;
            return n
        }
          , L = (Ae = [],
        we = [],
        Ce = Ae,
        _e = function() {
            var e = Ce;
            for (Ce = Ae.length ? we : Ae,
            Ee = !(be = !0); e.length; )
                e.shift()();
            be = !1
        }
        ,
        Le = function(e, t) {
            be && !t ? e.apply(this, arguments) : (Ce.push(e),
            Ee || (Ee = !0,
            (p.hidden ? u : n)(_e)))
        }
        ,
        Le._lsFlush = _e,
        Le)
          , t = function(n, e) {
            return e ? function() {
                L(n)
            }
            : function() {
                var e = this
                  , t = arguments;
                L(function() {
                    n.apply(e, t)
                })
            }
        }
          , S = function(e) {
            var t, n, a = function() {
                t = null,
                e()
            }, i = function() {
                var e = r.now() - n;
                e < 99 ? u(i, 99 - e) : (o || a)(a)
            };
            return function() {
                n = r.now(),
                t || (t = u(i, 99))
            }
        }
          , N = (ee = /^img$/i,
        te = /^iframe$/i,
        ne = "onscroll"in a && !/(gle|ing)bot/.test(navigator.userAgent),
        ae = 0,
        ie = 0,
        re = -1,
        se = function(e) {
            ie--,
            (!e || ie < 0 || !e.target) && (ie = 0)
        }
        ,
        oe = function(e) {
            return null == J && (J = "hidden" == C(p.body, "visibility")),
            J || !("hidden" == C(e.parentNode, "visibility") && "hidden" == C(e, "visibility"))
        }
        ,
        le = function(e, t) {
            var n, a = e, i = oe(e);
            for (W -= t,
            U += t,
            H -= t,
            D += t; i && (a = a.offsetParent) && a != p.body && a != m; )
                (i = 0 < (C(a, "opacity") || 1)) && "visible" != C(a, "overflow") && (n = a.getBoundingClientRect(),
                i = D > n.left && H < n.right && U > n.top - 1 && W < n.bottom + 1);
            return i
        }
        ,
        de = function() {
            var e, t, n, a, i, r, s, o, l, d, c, u, f = y.elements;
            if ((R = v.loadMode) && ie < 8 && (e = f.length)) {
                for (t = 0,
                re++; t < e; t++)
                    if (f[t] && !f[t]._lazyRace)
                        if (!ne || y.prematureUnveil && y.prematureUnveil(f[t]))
                            me(f[t]);
                        else if ((o = f[t][g]("data-expand")) && (r = 1 * o) || (r = ae),
                        d || (d = !v.expand || v.expand < 1 ? 500 < m.clientHeight && 500 < m.clientWidth ? 500 : 370 : v.expand,
                        y._defEx = d,
                        c = d * v.expFactor,
                        u = v.hFac,
                        J = null,
                        ae < c && ie < 1 && 2 < re && 2 < R && !p.hidden ? (ae = c,
                        re = 0) : ae = 1 < R && 1 < re && ie < 6 ? d : 0),
                        l !== r && (I = innerWidth + r * u,
                        $ = innerHeight + r,
                        s = -1 * r,
                        l = r),
                        n = f[t].getBoundingClientRect(),
                        (U = n.bottom) >= s && (W = n.top) <= $ && (D = n.right) >= s * u && (H = n.left) <= I && (U || D || H || W) && (v.loadHidden || oe(f[t])) && (F && ie < 3 && !o && (R < 3 || re < 4) || le(f[t], r))) {
                            if (me(f[t]),
                            i = !0,
                            9 < ie)
                                break
                        } else
                            !i && F && !a && ie < 4 && re < 4 && 2 < R && (j[0] || v.preloadAfterLoad) && (j[0] || !o && (U || D || H || W || "auto" != f[t][g](v.sizesAttr))) && (a = j[0] || f[t]);
                a && !i && me(a)
            }
        }
        ,
        V = de,
        G = 0,
        Q = v.throttleDelay,
        K = v.ricTimeout,
        Y = function() {
            X = !1,
            G = r.now(),
            V()
        }
        ,
        Z = o && 49 < K ? function() {
            o(Y, {
                timeout: K
            }),
            K !== v.ricTimeout && (K = v.ricTimeout)
        }
        : t(function() {
            u(Y)
        }, !0),
        ce = function(e) {
            var t;
            (e = !0 === e) && (K = 33),
            X || (X = !0,
            (t = Q - (r.now() - G)) < 0 && (t = 0),
            e || t < 9 ? Z() : u(Z, t))
        }
        ,
        ue = function(e) {
            var t = e.target;
            t._lazyCache ? delete t._lazyCache : (se(e),
            z(t, v.loadedClass),
            b(t, v.loadingClass),
            E(t, pe),
            A(t, "lazyloaded"))
        }
        ,
        fe = t(ue),
        pe = function(e) {
            fe({
                target: e.target
            })
        }
        ,
        ye = function(e) {
            var t, n = e[g](v.srcsetAttr);
            (t = v.customMedia[e[g]("data-media") || e[g]("media")]) && e.setAttribute("media", t),
            n && e.setAttribute("srcset", n)
        }
        ,
        ve = t(function(t, e, n, a, i) {
            var r, s, o, l, d, c;
            (d = A(t, "lazybeforeunveil", e)).defaultPrevented || (a && (n ? z(t, v.autosizesClass) : t.setAttribute("sizes", a)),
            s = t[g](v.srcsetAttr),
            r = t[g](v.srcAttr),
            i && (o = t.parentNode,
            l = o && f.test(o.nodeName || "")),
            c = e.firesLoad || "src"in t && (s || r || l),
            d = {
                target: t
            },
            z(t, v.loadingClass),
            c && (clearTimeout(O),
            O = u(se, 2500),
            E(t, pe, !0)),
            l && h.call(o.getElementsByTagName("source"), ye),
            s ? t.setAttribute("srcset", s) : r && !l && (te.test(t.nodeName) ? function(t, n) {
                try {
                    t.contentWindow.location.replace(n)
                } catch (e) {
                    t.src = n
                }
            }(t, r) : t.src = r),
            i && (s || l) && w(t, {
                src: r
            })),
            t._lazyRace && delete t._lazyRace,
            b(t, v.lazyClass),
            L(function() {
                var e = t.complete && 1 < t.naturalWidth;
                c && !e || (e && z(t, "ls-is-cached"),
                ue(d),
                t._lazyCache = !0,
                u(function() {
                    "_lazyCache"in t && delete t._lazyCache
                }, 9)),
                "lazy" == t.loading && ie--
            }, !0)
        }),
        me = function(e) {
            if (!e._lazyRace) {
                var t, n = ee.test(e.nodeName), a = n && (e[g](v.sizesAttr) || e[g]("sizes")), i = "auto" == a;
                (!i && F || !n || !e[g]("src") && !e.srcset || e.complete || c(e, v.errorClass) || !c(e, v.lazyClass)) && (t = A(e, "lazyunveilread").detail,
                i && T.updateElem(e, !0, e.offsetWidth),
                e._lazyRace = !0,
                ie++,
                ve(e, t, i, a, n))
            }
        }
        ,
        ge = S(function() {
            v.loadMode = 3,
            ce()
        }),
        he = function() {
            3 == v.loadMode && (v.loadMode = 2),
            ge()
        }
        ,
        ze = function() {
            F || (r.now() - B < 999 ? u(ze, 999) : (F = !0,
            v.loadMode = 3,
            ce(),
            e("scroll", he, !0)))
        }
        ,
        {
            _: function() {
                B = r.now(),
                y.elements = p.getElementsByClassName(v.lazyClass),
                j = p.getElementsByClassName(v.lazyClass + " " + v.preloadClass),
                e("scroll", ce, !0),
                e("resize", ce, !0),
                e("pageshow", function(e) {
                    if (e.persisted) {
                        var t = p.querySelectorAll("." + v.loadingClass);
                        t.length && t.forEach && n(function() {
                            t.forEach(function(e) {
                                e.complete && me(e)
                            })
                        })
                    }
                }),
                a.MutationObserver ? new MutationObserver(ce).observe(m, {
                    childList: !0,
                    subtree: !0,
                    attributes: !0
                }) : (m[s]("DOMNodeInserted", ce, !0),
                m[s]("DOMAttrModified", ce, !0),
                setInterval(ce, 999)),
                e("hashchange", ce, !0),
                ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(e) {
                    p[s](e, ce, !0)
                }),
                /d$|^c/.test(p.readyState) ? ze() : (e("load", ze),
                p[s]("DOMContentLoaded", ce),
                u(ze, 2e4)),
                y.elements.length ? (de(),
                L._lsFlush()) : ce()
            },
            checkElems: ce,
            unveil: me,
            _aLSL: he
        })
          , T = (M = t(function(e, t, n, a) {
            var i, r, s;
            if (e._lazysizesWidth = a,
            a += "px",
            e.setAttribute("sizes", a),
            f.test(t.nodeName || ""))
                for (i = t.getElementsByTagName("source"),
                r = 0,
                s = i.length; r < s; r++)
                    i[r].setAttribute("sizes", a);
            n.detail.dataAttr || w(e, n.detail)
        }),
        q = function(e, t, n) {
            var a, i = e.parentNode;
            i && (n = _(e, i, n),
            (a = A(e, "lazybeforesizes", {
                width: n,
                dataAttr: !!t
            })).defaultPrevented || (n = a.detail.width) && n !== e._lazysizesWidth && M(e, i, a, n))
        }
        ,
        k = S(function() {
            var e, t = x.length;
            if (t)
                for (e = 0; e < t; e++)
                    q(x[e])
        }),
        {
            _: function() {
                x = p.getElementsByClassName(v.autosizesClass),
                e("resize", k)
            },
            checkElems: k,
            updateElem: q
        })
          , P = function() {
            !P.i && p.getElementsByClassName && (P.i = !0,
            T._(),
            N._())
        };
        var x, M, q, k;
        var j, F, O, R, B, I, $, W, H, D, U, J, V, X, G, Q, K, Y, Z, ee, te, ne, ae, ie, re, se, oe, le, de, ce, ue, fe, pe, ye, ve, me, ge, he, ze;
        var be, Ee, Ae, we, Ce, _e, Le;
        return u(function() {
            v.init && P()
        }),
        y = {
            cfg: v,
            autoSizer: T,
            loader: N,
            init: P,
            uP: w,
            aC: z,
            rC: b,
            hC: c,
            fire: A,
            gW: _,
            rAF: L
        }
    }(e, e.document, Date);
    e.lazySizes = n,
    "object" == typeof module && module.exports && (module.exports = n)
}("undefined" != typeof window ? window : {}),
lazySizes.init(),
function(n, f, e) {
    function o(e, t) {
        return typeof e === t
    }
    function r(e) {
        var t = y.className
          , n = c._config.classPrefix || "";
        if (v && (t = t.baseVal),
        c._config.enableJSClass) {
            var a = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            t = t.replace(a, "$1" + n + "js$2")
        }
        c._config.enableClasses && (t += " " + n + e.join(" " + n),
        v ? y.className.baseVal = t : y.className = t)
    }
    function p() {
        return "function" != typeof f.createElement ? f.createElement(arguments[0]) : v ? f.createElementNS.call(f, "http://www.w3.org/2000/svg", arguments[0]) : f.createElement.apply(f, arguments)
    }
    function s(e, t) {
        if ("object" == typeof e)
            for (var n in e)
                u(e, n) && s(n, e[n]);
        else {
            var a = (e = e.toLowerCase()).split(".")
              , i = c[a[0]];
            if (2 == a.length && (i = i[a[1]]),
            void 0 !== i)
                return c;
            t = "function" == typeof t ? t() : t,
            1 == a.length ? c[a[0]] = t : (!c[a[0]] || c[a[0]]instanceof Boolean || (c[a[0]] = new Boolean(c[a[0]])),
            c[a[0]][a[1]] = t),
            r([(t && 0 != t ? "" : "no-") + a.join("-")]),
            c._trigger(e, t)
        }
        return c
    }
    function a(e, t, n, a) {
        var i, r, s, o, l, d = "modernizr", c = p("div"), u = ((l = f.body) || ((l = p(v ? "svg" : "body")).fake = !0),
        l);
        if (parseInt(n, 10))
            for (; n--; )
                (s = p("div")).id = a ? a[n] : d + (n + 1),
                c.appendChild(s);
        return (i = p("style")).type = "text/css",
        i.id = "s" + d,
        (u.fake ? u : c).appendChild(i),
        u.appendChild(c),
        i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(f.createTextNode(e)),
        c.id = d,
        u.fake && (u.style.background = "",
        u.style.overflow = "hidden",
        o = y.style.overflow,
        y.style.overflow = "hidden",
        y.appendChild(u)),
        r = t(c, e),
        u.fake ? (u.parentNode.removeChild(u),
        y.style.overflow = o,
        y.offsetHeight) : c.parentNode.removeChild(c),
        !!r
    }
    var l = []
      , d = []
      , t = {
        _version: "3.6.0",
        _config: {
            classPrefix: "cl",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(e, t) {
            var n = this;
            setTimeout(function() {
                t(n[e])
            }, 0)
        },
        addTest: function(e, t, n) {
            d.push({
                name: e,
                fn: t,
                options: n
            })
        },
        addAsyncTest: function(e) {
            d.push({
                name: null,
                fn: e
            })
        }
    }
      , c = function() {};
    c.prototype = t,
    c = new c;
    var u, i, y = f.documentElement, v = "svg" === y.nodeName.toLowerCase(), m = t._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
    t._prefixes = m,
    c.addTest("video", function() {
        var e = p("video")
          , t = !1;
        try {
            (t = !!e.canPlayType) && ((t = new Boolean(t)).ogg = e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, ""),
            t.h264 = e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, ""),
            t.webm = e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, ""),
            t.vp9 = e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, ""),
            t.hls = e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, ""))
        } catch (e) {}
        return t
    }),
    c.addTest("csspositionsticky", function() {
        var e = "position:"
          , t = p("a").style;
        return t.cssText = e + m.join("sticky;" + e).slice(0, -e.length),
        -1 !== t.position.indexOf("sticky")
    }),
    u = o(i = {}.hasOwnProperty, "undefined") || o(i.call, "undefined") ? function(e, t) {
        return t in e && o(e.constructor.prototype[t], "undefined")
    }
    : function(e, t) {
        return i.call(e, t)
    }
    ,
    t._l = {},
    t.on = function(e, t) {
        this._l[e] || (this._l[e] = []),
        this._l[e].push(t),
        c.hasOwnProperty(e) && setTimeout(function() {
            c._trigger(e, c[e])
        }, 0)
    }
    ,
    t._trigger = function(e, t) {
        if (this._l[e]) {
            var n = this._l[e];
            setTimeout(function() {
                var e;
                for (e = 0; e < n.length; e++)
                    (0,
                    n[e])(t)
            }, 0),
            delete this._l[e]
        }
    }
    ,
    c._q.push(function() {
        t.addTest = s
    });
    var g = t.testStyles = a;
    c.addTest("touchevents", function() {
        var t;
        if ("ontouchstart"in n || n.DocumentTouch && f instanceof DocumentTouch)
            t = !0;
        else {
            var e = ["@media (", m.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
            g(e, function(e) {
                t = 9 === e.offsetTop
            })
        }
        return t
    });
    var h, z = (h = n.matchMedia || n.msMatchMedia) ? function(e) {
        var t = h(e);
        return t && t.matches || !1
    }
    : function(e) {
        var t = !1;
        return a("@media " + e + " { #modernizr { position: absolute; } }", function(e) {
            t = "absolute" == (n.getComputedStyle ? n.getComputedStyle(e, null) : e.currentStyle).position
        }),
        t
    }
    ;
    t.mq = z,
    c.addTest("hovermq", z("(hover)")),
    function() {
        var e, t, n, a, i, r;
        for (var s in d)
            if (d.hasOwnProperty(s)) {
                if (e = [],
                (t = d[s]).name && (e.push(t.name.toLowerCase()),
                t.options && t.options.aliases && t.options.aliases.length))
                    for (n = 0; n < t.options.aliases.length; n++)
                        e.push(t.options.aliases[n].toLowerCase());
                for (a = o(t.fn, "function") ? t.fn() : t.fn,
                i = 0; i < e.length; i++)
                    1 === (r = e[i].split(".")).length ? c[r[0]] = a : (!c[r[0]] || c[r[0]]instanceof Boolean || (c[r[0]] = new Boolean(c[r[0]])),
                    c[r[0]][r[1]] = a),
                    l.push((a ? "" : "no-") + r.join("-"))
            }
    }(),
    r(l),
    delete t.addTest,
    delete t.addAsyncTest;
    for (var b = 0; b < c._q.length; b++)
        c._q[b]();
    n.Modernizr = c
}(window, document),
function(a) {
    "use strict";
    a.loadCSS || (a.loadCSS = function() {}
    );
    var i = loadCSS.relpreload = {};
    if (i.support = function() {
        var t;
        try {
            t = a.document.createElement("link").relList.supports("preload")
        } catch (e) {
            t = !1
        }
        return function() {
            return t
        }
    }(),
    i.bindMediaToggle = function(e) {
        var t = e.media || "all";
        function n() {
            e.addEventListener ? e.removeEventListener("load", n) : e.attachEvent && e.detachEvent("onload", n),
            e.setAttribute("onload", null),
            e.media = t
        }
        e.addEventListener ? e.addEventListener("load", n) : e.attachEvent && e.attachEvent("onload", n),
        setTimeout(function() {
            e.rel = "stylesheet",
            e.media = "only x"
        }),
        setTimeout(n, 3e3)
    }
    ,
    i.poly = function() {
        if (!i.support())
            for (var e = a.document.getElementsByTagName("link"), t = 0; t < e.length; t++) {
                var n = e[t];
                "preload" !== n.rel || "style" !== n.getAttribute("as") || n.getAttribute("data-loadcss") || (n.setAttribute("data-loadcss", !0),
                i.bindMediaToggle(n))
            }
    }
    ,
    !i.support()) {
        i.poly();
        var e = a.setInterval(i.poly, 500);
        a.addEventListener ? a.addEventListener("load", function() {
            i.poly(),
            a.clearInterval(e)
        }) : a.attachEvent && a.attachEvent("onload", function() {
            i.poly(),
            a.clearInterval(e)
        })
    }
    "undefined" != typeof exports ? exports.loadCSS = loadCSS : a.loadCSS = loadCSS
}("undefined" != typeof global ? global : this);

